import React from 'react';
import { PricingCard } from './PricingCard';
export function FinalCTA() {
  return <div className="bg-white" data-id="element-53">
      <div className="max-w-2xl mx-auto text-center py-6 px-4" data-id="element-54">
        <h2 className="text-xl sm:text-2xl font-heading font-bold text-brand-primary mb-4" data-id="element-55">
          💪 SÌ! VOGLIO RIVOLUZIONARE LA MIA SALUTE ORA
        </h2>
      </div>
      <PricingCard idAttr="pricing-bottom" data-id="element-56" />
    </div>;
}